import Dashboard from "../layouts/Dashboard/Dashboard.jsx";



var Routes = [{ path: "/index", name: "Dashboard", component: Dashboard }];

export default Routes;

